// noinspection JSUnusedGlobalSymbols

import moment from 'moment';

import {config} from '@isudio/config';

export enum LogLevels {
  off = 'off',
  all = 'all',
  debug = 'debug',
  info = 'info',
  event = 'event',
  warn = 'warn',
  error = 'error'
}

export enum LogTargets {
  all = 'all',
  console = 'console',
  db = 'db',
}

export class Logger {
  constructor() {
  }

  private logLevel: LogLevels | string = config.log.level || LogLevels.off;
  private logTarget: LogTargets | string = config.log.target || LogTargets.console;

  log(log: any) {
    if (this.logLevel === LogLevels.all || this.logLevel === LogLevels.debug) {
      this.write(log, LogLevels.debug);
    }
  }

  debug(log: any, data?: any) {
    if (this.logLevel === LogLevels.all || this.logLevel === LogLevels.debug) {
      this.write(log, LogLevels.debug, data);
    }
  }

  info(log: any, data?: any) {
    if (this.logLevel === LogLevels.all || this.logLevel === LogLevels.info) {
      this.write(log, LogLevels.info, data);
    }
  }

  event(log: any, data?: any) {
    if (this.logLevel === LogLevels.all || this.logLevel === LogLevels.event) {
      this.write(log, LogLevels.event, data);
    }
  }

  warn(log: any, data?: any) {
    if (this.logLevel === LogLevels.all || this.logLevel === LogLevels.warn) {
      this.write(log, LogLevels.warn, data);
    }
  }

  error(log: any, data?: any) {
    if (this.logLevel === LogLevels.all || this.logLevel === LogLevels.error) {
      this.write(log, LogLevels.error, data);
    }
  }

  public write(log: any, type: LogLevels, data?: any) {
    if (this.logLevel === LogLevels.off) return;

    const dt = moment().format('DD-MM-YYYY hh:mm:ss a');

    if (this.logTarget === LogTargets.all || this.logTarget === LogTargets.console) {
      this.consoleLog(dt, type, log, data);
    }
  }

  private consoleLog(dt: string, type: LogLevels, log: string, data: any = '') {
    switch (type) {
      case LogLevels.debug:
        console.info(
          '%c[%s] %c[%s] %c%s',
          'color:wheat', dt,
          'color:darkKhaki', type.toUpperCase(),
          'color:lightYellow', log, data
        );
        break;

      case LogLevels.info:
        console.info(
          '%c[%s] %c[%s] %c%s',
          'color:wheat', dt,
          'color:mediumSlateBlue', type.toUpperCase(),
          'color:cornflowerBlue', log, data
        );
        break;

      case LogLevels.event:
        console.warn(
          '%c[%s] %c[%s] %c%s',
          'color:wheat', dt,
          'color:darkCyan', 'EVENT',
          'color:mediumAquamarine', log, data
        );
        break;

      case LogLevels.warn:
        console.warn(
          '%c[%s] %c[%s] %c%s',
          'color:wheat', dt,
          'color:coral', 'WARNING',
          'color:darkOrange', log, data
        );
        break;

      case LogLevels.error:
        console.error(
          '%c[%s] %c[%s] %c%s',
          'color:wheat', dt,
          'color:indianRed', type.toUpperCase(),
          'color:lightCoral', log, data
        );
        break;

      default:
        return;
    }
  }
}
